module.exports = __webpack_public_path__ + "media/images/winner--left-2e63c7205146d6b210cb2c9e7a193513.png";